<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js'
import { interactionMixin } from "src/modules/interactions_module.js";
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js'
import { mqLess } from 'src/modules/viewport_module';
import { get } from 'lodash';
import Intersect from 'vue-intersect';

export default {
  mixins: [fandomBasicMixin, kenwoodItalyBasicMixin, interactionMixin],
  props: {
    trackTileClick: Array,
    ignoreUrl: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadVideo: false
    }
  },
  components: { Intersect },
  mounted() {
    this.registerAnimation();
    // google analytics
    if (!!this.trackTileClick){
      Vue.nextTick(() => {
        KenwoodItaly.trackLinkVisited(`#ref-${this.easyadminId}-link`, this.trackTileClick[0], this.trackTileClick[1], this.content.name);
      });
    }
  },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getContentURL: Fandom.getContentURL,
    startVideo(event) {
      if (this.content.background_video && this.toggleVideoCondition(event)) {
        this.loadVideo = true;

        // We await the reprint so that the video is presented on the page
        Vue.nextTick(() => { 
          const video = $(this.$refs.video)[0];
          video.play();
        });
      }
    },
    pauseVideo(event) {
      if (this.content.background_video && this.loadVideo && this.toggleVideoCondition(event)) {
        const video = $(this.$refs.video)[0];
        video.pause();
        video.currentTime = 0;

        this.loadVideo = false;
      }
    },
    toggleVideoCondition(event) {
      return (event == 'mouseenter' && !mqLess("sm")) ||
             (event == 'intersect' && mqLess("sm"))
    }
  },
  computed: {
    isTextBig() {
      if(this.content.isotope_size == "largesquarecontent"){
        return "is-big-title";
      }
    },
    favourite() {
      return (this.content.interactions && this.content.interactions["favourite"]) ? this.content.interactions["favourite"] : false;
    },
    owner() {
      if(Fandom.exists(this.content.owned_by) && this.pageModel.id_to_user[this.content.owned_by]) {
        return this.pageModel.id_to_user[this.content.owned_by];
      }
    },
    tileUrl() {
      return this.ignoreUrl ? Fandom.applyContextToUrl(this.content.slug) : this.getContentURL(this.content);
    },
    tileTarget() {
      return this.ignoreUrl ? '_self' : this.getTarget(this.content.url);
    },
  }
}
</script>

<template>
  <intersect @enter="startVideo('intersect')" @leave="pauseVideo('intersect')">
    <div
      v-easyadmin="easyadminId"
      :class="contentType"
      class="position-absolute-center bg-transition"
      @mouseenter="startVideo('mouseenter')"
      @mouseleave="pauseVideo('mouseenter')"
      tile-component
    >
      <a :href="tileUrl" :id="`ref-${easyadminId}-link`" :target="tileTarget" class="container-fluid h-100 p-0 d-flex flex-column justify-content-between">
        <div class="bg-cover-center position-absolute-center bg lazy-bg" :lazy-src="getContentResponsiveImageURL('thumbnail')"></div>
        <div v-if="!content.hide_gradient" class="position-absolute-center linear-gradient-y"></div>
        <div class="position-absolute-center" v-if="loadVideo && content.background_video">
          <video ref="video" loop muted playsinline webkit-playsinline class="w-100 h-100">
            <source :src="content.background_video.url" type="video/mp4">
          </video>
        </div>
        <div class="row tile__top mx-0 pt-3 pt-md-4">
          <div v-if="content.category" class="col-12 px-3 px-md-4">
            <span :class="`bg-${color}`" class="category text-uppercase px-1 py-1 px-sm-2 py-md-2 font-sm m-0">{{content.category}}</span>
          </div>
        </div>
        <div class="row tile__bottom mx-0 pb-3 pb-md-4">
          <div v-if="content.title_composed || content.title" class="col-12 px-3 px-md-4 pt-3">
            <div v-if="content.title_composed" class="title-composed">
              <h3 v-for="titleLine in content.title_composed" :class="[getTitleStyle(titleLine), isTextBig]" class="h5 m-0">{{titleLine.title}}</h3>
            </div>
            <div v-else class="title-simple">
              <h3 :class="[isTextBig]" class="h5 m-0 title-italic">{{content.title}}</h3>
            </div>
          </div>
          <div v-if="owner || favourite" class="col-12 px-3 px-md-4 pt-3 px-md-4 d-flex" :class="{'justify-content-between': !(favourite && !owner), 'justify-content-end': favourite && !owner}">
            <div v-if="owner" class="owner-info d-flex align-items-center pl-0" >
              <div v-if="owner.avatar" class="owner-avatar bg-cover-center" :style="{'background-image': getBackgroundUrl(owner.avatar.url)}"></div>
              <span class="pl-2 font-sm">By {{owner.username}}</span>
            </div>
            <div v-if="favourite" class="favourite text-left d-flex align-items-center justify-content-center" @click.stop.prevent="openFavouriteModal(containerContent, favourite, favourite.interaction)">
              <i class="fa-bookmark" :class="[isFavourite(containerContent, favourite.interaction) ? 'fas text-red-cabbage' : 'fal']"></i>
            </div>
          </div>
        </div>
      </a>
    </div>
  </intersect>
</template>

<style lang="scss" scoped>

[tile-component] {
  color: $white;
  overflow: hidden;
  cursor: pointer;

  video {
    object-fit: cover;
  }

  a {
    text-decoration: none;
    color: inherit;
    &:hover {
      color: inherit;
      text-decoration: none;
    }
  }

  .linear-gradient-y {
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, #000000);
    opacity: .16;
  }

  .title-composed, .title-simple {
    .title-italic {
      font-style: italic;
    }
    .title-uppercase {
      text-transform: uppercase;
    }
    .title-underline {
      text-decoration: underline;
    }
  }

  .favourite {
    i {
      font-size: 1.75rem;
    }
  }

  .category {
    letter-spacing: 0.96px;
  }

  .owner-info {
    .owner-avatar {
      height: 42px;
      width: 42px;
      border-radius: 50%;
    }
  }

  @include media-breakpoint-up(lg) {
    .h5.is-big-title {
      font-size: 2.625rem;
    }

    .h5.title-f-11 {
      font-size: 1.2rem;
      text-align: center;
    }
  }

  @include media-breakpoint-down(md) {
    .favourite {
      i {
        font-size: 1.25rem;
      }
    }
  }

}
</style>
